import { render, staticRenderFns } from "./largesScreen5.vue?vue&type=template&id=1d71894b&scoped=true"
import script from "./largesScreen5.vue?vue&type=script&lang=js"
export * from "./largesScreen5.vue?vue&type=script&lang=js"
import style0 from "./largesScreen5.vue?vue&type=style&index=0&id=1d71894b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d71894b",
  null
  
)

export default component.exports